<template>
    <!-- ========== FEATURES ========== -->
    <section class="lightgrey_bg" id="features">
        <div class="container">
            <div class="main_title mt_wave a_center">
                <h2 v-lang.our_awesome_services></h2>
            </div>
            <p class="main_description a_center" v-lang.our_awesome_services_description></p>

            <div class="row">
                <div class="col-md-7">
                    <div v-if="selected!=null">
                        <transition name="fade">
                            <img id="img_service" alt="" v-bind:src="selected.src" class="img-responsive">
                        </transition>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="owl-thumbs" data-slider-id="features">
                        <owl-item @change="disableOthers" v-for="(service, index) in services" :service="service" :index="index" key="service.id"></owl-item>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import config from '../../config/app';
    import owlItem from './Item.vue';
    import _ from 'lodash';
    export default {
        components : {
            'owl-item' : owlItem
        },
        data : function(){
            return {
                services : config.services,
                selected : null
            }
        },
        methods : {
            disableOthers : function( service ){
                let self = this;
                $('#img_service').fadeOut(400).fadeIn();
                _.forEach( self.services, function(item){
                    if( item.id != service.id )
                    {
                        item.selected = false;
                    }
                });
                self.selected = service;
                window.clearInterval(this.interval);
                this.initInterval();
            },
            initInterval : function(){
                var self = this;
                this.interval = setInterval(function cycle(){
                    let index = self.selected.index;
                    let nextIndex = 0;
                    if( (index+1) <= ( self.services.length -1 )  )
                    {
                        nextIndex = index +1;
                    }
                    self.services[index].selected = false;
                    self.services[nextIndex].selected = true;
                    self.selected = self.services[nextIndex];
                }.bind(this), 4000);
            }
        },
        mounted : function(){
            let self = this;
            if( this.services.length > 0 )
            {
                this.services[0].selected = true;
                this.selected = this.services[0];
                this.initInterval();
            }
        },
        beforeDestroy : function(){
            _.forEach(this.services, function( item ){
                item.selected = false;
            });
            window.clearInterval(this.interval);
            this.unsubscribe();
        },
        created : function(){
            var self = this;
            this.unsubscribe  = this.$store.subscribe((mutation,state) => {
                self.$language = self.$store.state.language;
            });
        },
    }
</script>


// WEBPACK FOOTER //
// Services.vue?08cb8197